<template>
  <div class="groupsPrdtListing">
    <header>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
      >
        <g fill="#000" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <router-link :to="{path: '/lucky-winner-list'}" tag="div" class="winner-button">
        <img src="../../assets/images/detail/crowns.svg" />
        &nbsp; {{$t('ourWinners')}}
      </router-link>
    </header>
    <section class="detail_content">
      <div class="img-block">
        <img :src="salesDetails.displayImage" />
      </div>
      <div class="share-option">
        <span class="free-tag">{{$t('getFree')}}</span>
        <div class="prod-detail">
          <p class="prod-name">{{salesDetails.productName}}</p>
          <div class="prod-price">
            <strong class="mrp">
              <span style="font-weight:500">₹</span>​ 0
            </strong>
            <strike class="total-price">₹ {{salesDetails.mrp}}</strike>
          </div>
          <p class="winner-note">{{$t('shareThisLuckyItemMessage')}}</p>
          <div style="display:flex;justify-content:center;align-items:center">
            <span class="view-icon" @click="sharedUsersClicked(salesDetails.saleReferenceID)">
              <img src="../../assets/images/detail/view.svg" />
            </span>
            <div
              class="whatsapp-share"
              @click="shareFunc(salesDetails.displayImage, salesDetails.saleReferenceID)"
            >
              <div style="display:flex;justify-content:center;align-items:center">
                <whatsapp-icon />
              {{$t('shareOnWhatsapp')}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomToUp" v-if="isActivePopUp"></div>
      <div class="middle_popup" :class="{'popUp' : isActivePopUp, 'minHeight': noShareList}">
        <div v-if="clickUserList.clickUserDTOs && clickUserList.clickUserDTOs.length">
          <div class="popup_header">
            <span class="prdt_hdng">{{$t('howManyShared')}}</span>
            <span class="user_count">{{clickUserList.totalRecords}} {{$t('people')}}</span>
          </div>
          <ul>
            <li v-for="(personList, index) in clickUserList.clickUserDTOs" :key="index">
              <span class="img_wrapper">
                <img
                  v-if="personList.profileImage"
                  :src="personList.profileImage"
                  alt="profile-image"
                />
                <img src="../../assets/images/dummy.png" alt="profile-image" v-else />
              </span>
              <p class="userdetail">
                <span class="name">{{personList.userName}}</span>
                <span
                  class="location"
                  v-if="personList.location"
                >{{$t('from' ,{location:personList.location})}}</span>
              </p>
              <!-- <span class="cut_amount">₹ 123</span> -->
            </li>
          </ul>
        </div>
        <div v-if="noShareList">
          <p>{{$t('youHaveNotShared')}}</p>
        </div>
        <span class="closePopUp" @click="isActivePopUp =!isActivePopUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import WhatsappIcon from "@/components/Icons/WhatsappIcon";
export default {
  name: "LuckyDetail",
  components: {
    WhatsappIcon
  },
  data() {
    return {
      loading: false,
      isActivePopUp: false,
      salesDetails: {},
      availableLuckyUserIndex: 0,
      clickUserList: [],
      noShareList: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getAdsSaleDetail() {
      this.loading = false;
      const obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        referralUserId: this.$route.query.referralUserId || null
      };
      ApiCaller(constant.BASE_URL, "get-item-lite-info", "post", obj)
        .then(data => {
          this.salesDetails = data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    sharedUsersClicked(itemId) {
      this.isActivePopUp = true;
      this.availableLuckyUserIndex = 0;
      this.loading = true;
      ApiCaller(
        constant.GAMING_API_URL,
        "click/user/" + itemId + "/" + this.availableLuckyUserIndex,
        "get"
      )
        .then(data => {
          this.loading = false;
          this.clickUserList = data.data;
          if (!data.data.clickUserDTOs.length) {
            this.noShareList = true;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    shareFunc(shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true;
        this.$store
          .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID })
          .then(data => {
            this.shareLinkData = data.data;
            this.loading = false;
            const obj = {
              message: data.data.shareMessage,
              imageUrl: shareImage
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + data.data.shareMessage);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    }
  },
  mounted() {
    this.getAdsSaleDetail();
  }
};
</script>
<style scoped lang="scss">
.minHeight {
  min-height: 60px;
  text-align: center;
}
header {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
}
.winner-button {
  border: 1.3px solid #ff4b00;
  width: fit-content;
  padding: 5px 10px;
  border-radius: 5px;
  color: #ff4b00;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-family: "Roboto", sans-serif;
}
.detail_content {
  padding: 0;
  .img-block {
    height: 410px;
    width: 100%;
    position: relative;
    margin-bottom: 7px;
    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .share-option {
    border-top-right-radius: 62px;
    background: #0278ff;
    .free-tag {
      background: #fff;
      color: #62ba06;
      font-size: 0.875em;
      font-weight: 600;
      padding: 5px 25px 5px 15px;
      margin: 10px 0;
      display: inline-block;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 10px solid #0278ff;
        top: 0;
        right: 0px;
      }
    }
    .prod-detail {
      font-family: "Hind", sans-serif;
      padding: 0 15px 10px;
      color: #fff;
      .prod-name {
        font-size: 1.25em;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .prod-price {
        font-size: 1.125em;
        strike {
          padding-left: 15px;
        }
      }
      .winner-note {
        font-size: 0.875em;
        margin: 8px 0;
      }
      .view-icon {
        display: inline-block;
        padding: 12px 15px;
        background: #fff;
        border-radius: 10px;
        line-height: 0;
      }
      .whatsapp-share {
        display: inline-block;
        padding: 0 15px;
        background: #ff8902;
        border-radius: 10px;
        line-height: 0;
        width: 78%;
        margin-left: 4%;
      }
    }
  }
}
.noShareList {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 80%;
  text-align: center;
  font-weight: 600;
}
</style>
    